// Funzioni comuni ai form della scheda ricorso e dei ricorsi collettivi: un solo punto.

// Messaggio leggibile da un errore dell'API: stringa del backend, elenco Pydantic 422
// ("campo: messaggio; …") o, in mancanza, il testo di ripiego. Mai l'oggetto Pydantic a video.
export function msgErrore(e, fallback) {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map(x => (x.loc ? x.loc.slice(-1)[0] + ': ' : '') + (x.msg || JSON.stringify(x))).join('; ');
  return JSON.stringify(d);
}

// "Cifra al netto": gli importi si salvano lordi (+4% cassa, +22% IVA), arrotondati ai centesimi.
export const lordoDaNetto = (netto) => Math.round(parseFloat(netto) * 1.04 * 1.22 * 100) / 100;

// Campi number degli importi: la rotella del mouse sul campo con il focus ne cambiava il valore
// (compensi da −1 a −6 salvati per errore). Con il blur la rotella torna a scorrere la pagina.
export const senzaRotella = (e) => e.currentTarget.blur();
